<!DOCTYPE html>
<!-- This ng-container is used as a wrapper for the lottery extension component -->
@if (offerData$ | async; as offerData) {
  <ng-container class="no-scrollbar">
    <!-- Ionic Grid for layout -->
    <ion-grid class="ion-no-padding page-container">
      <!-- Header Row -->
      <ion-row class="card-header">
        <ion-col size="10">
          <h1 class="page-title">{{ offerData?.content?.[languageCode]?.title }}</h1>
          <p class="page-subtitle">{{ offerData?.content?.[languageCode]?.description }}</p>
        </ion-col>
        <ion-col size="2">
          <!-- Close button -->
          <div class="close-btn" (click)="closeDialog()"><img alt="close-image" src="../../../assets/icon/gray-close.png"></div>
        </ion-col>
      </ion-row>
      <!-- Main content section -->
      <div class="big-card">
        <div class="card-head" [ngStyle]="{'background': offerData?.background}">
          <!-- Icon and offer details -->
          <div class="ball-icon">
            <img alt="ball-image" src="../../../assets/icon/po-image.png">
          </div>
          <div class="offer-details">
            <h2>{{ offerData?.content?.[languageCode]?.image_title }}</h2>
            <h3>{{ offerData?.content?.[languageCode]?.image_description }}</h3>
          </div>
        </div>
        <!-- Offer options -->
        <div class="card-body">
          <!-- Offer options -->
          @for (offer of offerArray; track offer; let i = $index) {
            <ion-row class="offer-option-height border-bottom offer-option">
              <ion-col size="9" class="offer-desc">
                <ion-item class="no-ripple" lines="none" (click)="selectOffer(i)">
                  <ion-checkbox class="ion-checkbox" [checked]="i === selectedOfferIndex" mode="ios" color="secondary"></ion-checkbox>
                  <ion-label class="offer-period"><strong>{{currencySymbol +
                  offerData?.content?.[languageCode]?.[offerArray[i].id]?.titleBold }}</strong> {{
                  offerData?.content?.[languageCode]?.[offerArray[i].id]?.titleRegular }} <br />
                  <span>
                    {{ (offerArray[i]?.credit_back ? currencySymbol : '') +
                    offerData?.content?.[languageCode]?.[offerArray[i].id]?.description }}
                  </span>
                </ion-label>
              </ion-item>
            </ion-col>
            <ion-col size="3">
              <ion-chip class="ion-chip">
                <ion-label>
                  {{ offerArray[i].discount }}% off
                </ion-label>
              </ion-chip>
            </ion-col>
          </ion-row>
        }
        <!-- Row for the checkout button -->
        <ion-row>
          <ion-button (click)="joinOffer(offerData)" size="small" expand="block" class="btn-checkout">
            <span>{{'custom_offer.Join' | translate}}</span>
          </ion-button>
        </ion-row>
      </div>
    </div>
  </ion-grid>
</ng-container>
}
